import { css } from '@emotion/react';
import React, { createContext } from 'react';
import { AnalyticsDashBoardType, AnalyticsPageType } from 'redux/schemas/app/analytics';
import { Course } from 'redux/schemas/models/course';
import QrveyWrapper from './qrvey-wrapper';

const styles = css`
  &.container {
    max-width: 100%;

    .charts {
      display:flex;
      flex-direction:column;
      padding-bottom: 80px;
      min-width: 320px;

      .chart {
        margin-top:25px;

        &.small {
          max-width:400px;
        }
      }
    }
  }
`;

export type AnalyticsContextState = {
  dashboardType: AnalyticsDashBoardType
  configKeyName?: string
  pageIdKey?: string
  questionSetId?: number
  cohorts?: Course[]
  analyticsPageType?: AnalyticsPageType
  catalogId?: string
  institutionId?: number
  prePostSurveyConfigurationId?: number
};

const analyticsInitialState: AnalyticsContextState = {
  dashboardType: null,
  configKeyName: '',
  pageIdKey: '',
  questionSetId: null,
  analyticsPageType: null,
  catalogId: '',
  institutionId: null,
  prePostSurveyConfigurationId: null,
};

export const AnalyticsContext = createContext(analyticsInitialState);

type AnalyticsProps = AnalyticsContextState & {
  children: React.ReactNode
};

/**
 * Wraps the Qrvey component which passed as children with the context
 *
 * @param {AnalyticsDashBoardType} dashboardType
 * @param {string} configKeyName
 * @param {string} pageIdKey
 * @param {number} questionSetId
 * @param {React.ReactNode} children Use QrveyWrapper for analytics without panels, and QrveyPanelsWrapper when panels used
 */

const AnalyticsDashboard = ({ children, ...props }: AnalyticsProps) => (
  <AnalyticsContext.Provider value={{ ...props }}>
    <div css={styles} className='container'>
      <div className='charts'>
        {children}
      </div>
    </div>
  </AnalyticsContext.Provider>
);

export default AnalyticsDashboard;

export const AnalyticsInstitutionDashboard = () => (
  <AnalyticsDashboard dashboardType={AnalyticsDashBoardType.INSTITUTION}>
    <QrveyWrapper />
  </AnalyticsDashboard>
);
